const accountsSection01Content = `
<div class="banner-heading">
    <div class="main-holder">
        <div class="text text-center">
            <p class="ttl">Choose Your Account</p>
            <h1>Trading Accounts</h1>
            <p class="centered">Choose the account type that matches your experience level and trading objectives. All accounts<br class="d-none d-md-inline"> include access to our professional trading platform.</p>
        </div>
    </div>
</div>
`;

export default accountsSection01Content;